<div class="striped-bg"></div>
<section id="home-contact">
	@defer (on viewport; when forceLoad) {
		<div class="section-left" @deferState>
			<div id="ci-wrapper">
				<div id="contact-info">
					<h2>Get in touch</h2>
					<p>Questions? Or maybe you&rsquo;d like to discuss a project and/or get a quote? Feel free to reach out to me via the
						contact form<span id="contact-dir"></span>, or shoot me an email if you prefer!<br /><br /><br />
						<a href="mailto:create@nhdsgn.com">create&#64;nhdsgn.com</a>
					</p>
					<app-social 
						enabled="['linkedin', 'twitter', 'behance']"
						enabled="linkedin, twitter, behance, resume"
						iconColor="orange"
					>
					</app-social>
				</div>
			</div>
		</div>
	} @placeholder {
		<div class="defer-ph"></div>
	}
	@defer (on viewport; when forceLoad) {
		<div class="section-right" @deferState>
			<div id="cf-wrapper">
				<app-contact-form></app-contact-form>
			</div>
		</div>
	} @placeholder {
		<div class="defer-ph"></div>
	}
</section>